import configProduction from "./config.production";

let config = {
  // API: "http://192.168.1.8:3000/", //Local Dev
  API: "https://srv522487.hstgr.cloud", //Prod Nova Api
}

if (process.env.VUE_APP_ENV == "production") {
  config = Object.assign(config, configProduction);
}

export default config;
